const filterEvents = (events) => {
  let filteredEvents = events.filter(
    (event) =>
      event.typeId === 1 ||
      event.typeId === 11 ||
      event.typeId === 8 ||
      event.typeId === 18
  );
  return filteredEvents;
};

const computeWorkedTimeToday = (events, date = new Date()) => {
  let workedTimeToday = 0;
  let filteredSortedEvents = filterEvents(events);

  /// find and remove first 'entry' events
  let indexOfFirstEntryEvent = filteredSortedEvents.findIndex(
    (event) => event.typeId === 1 || event.typeId === 11
  );
  filteredSortedEvents.splice(0, indexOfFirstEntryEvent);

  // /// create helper entryExitStrings array
  let entryExitStrings: any = [];
  filteredSortedEvents.forEach((event, eventindex) => {
    if (event.typeId === 1 || event.typeId === 11)
      entryExitStrings.push("entry");
    else entryExitStrings.push("exit");
  });

  for (let i = entryExitStrings.length - 1; i >= 0; i--) {
    if (entryExitStrings[i - 1] === entryExitStrings[i]) {
      entryExitStrings.splice(i, 1);
      filteredSortedEvents.splice(i, 1);
    }
  }
  for (let i = 0; i < filteredSortedEvents.length; i = i + 2) {
    if (filteredSortedEvents[i + 1]) {
      workedTimeToday =
        workedTimeToday +
        new Date(filteredSortedEvents[i + 1].time).getTime() -
        new Date(filteredSortedEvents[i].time).getTime();
    } else {
      workedTimeToday =
        workedTimeToday +
        new Date().getTime() -
        new Date(filteredSortedEvents[i].time).getTime();
    }
  }
  // return 28795;
  return Math.floor(workedTimeToday / 1000);
};

export { computeWorkedTimeToday, filterEvents };
